// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/api/epd.proto (package knop.ui.v1.api, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Location } from "../model/location_pb.js";
import { Action } from "../model/action_pb.js";
import { ShuntingUnit } from "../model/shunting_unit_pb.js";

/**
 * @generated from message knop.ui.v1.api.EpdRequest
 */
export class EpdRequest extends Message<EpdRequest> {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId = "";

  constructor(data?: PartialMessage<EpdRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.EpdRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EpdRequest {
    return new EpdRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EpdRequest {
    return new EpdRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EpdRequest {
    return new EpdRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EpdRequest | PlainMessage<EpdRequest> | undefined, b: EpdRequest | PlainMessage<EpdRequest> | undefined): boolean {
    return proto3.util.equals(EpdRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.EpdResponse
 */
export class EpdResponse extends Message<EpdResponse> {
  /**
   * @generated from field: knop.ui.v1.model.Location location = 1;
   */
  location?: Location;

  /**
   * @generated from field: repeated knop.ui.v1.model.Action actions = 2;
   */
  actions: Action[] = [];

  /**
   * @generated from field: map<string, knop.ui.v1.model.ShuntingUnit> shunting_units_by_id = 3;
   */
  shuntingUnitsById: { [key: string]: ShuntingUnit } = {};

  constructor(data?: PartialMessage<EpdResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.EpdResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "location", kind: "message", T: Location },
    { no: 2, name: "actions", kind: "message", T: Action, repeated: true },
    { no: 3, name: "shunting_units_by_id", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: ShuntingUnit} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EpdResponse {
    return new EpdResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EpdResponse {
    return new EpdResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EpdResponse {
    return new EpdResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EpdResponse | PlainMessage<EpdResponse> | undefined, b: EpdResponse | PlainMessage<EpdResponse> | undefined): boolean {
    return proto3.util.equals(EpdResponse, a, b);
  }
}

